import { useEffect, useRef } from 'react';

/**
 * Hook to cache a value which will be held in ref to avoid rerenders.
 * passing a nullsih value will return the previously held value.
 * passing a new value will overwrite the value in cache
 * */
export function useCached<T>(value: T | undefined | null): T {
  const cachedValue = useRef(value);

  useEffect(() => {
    if (value) {
      cachedValue.current = value;
    }
  }, [value]);

  if (value) {
    return value;
  }

  return cachedValue.current as T;
}
